export { default } from './GeoPin'
